export default __webpack_public_path__ + "static/media/BikeWhite.a5246526.png";